import React, { useEffect } from "react";
import { Flex, VStack, Text, Box, Heading, HStack, Spinner } from "@chakra-ui/react";
import { useRegisterSkolFederationen } from "./hooks";
import { useTranslation } from "react-i18next";
import { getAxiosInstance } from "services/api";
import { idpUrl } from "services/config";
import { useParams } from "react-router-dom";

const invalidCredentialsErrorMessage = "Registreringen misslyckades";

export const RegisterSkolFederationen = () => {
  const { handleRegister, authError, isLoading } = useRegisterSkolFederationen();
  const { t } = useTranslation();
  const { activationToken } = useParams<{ activationToken: string }>();

  useEffect(() => {
    const fetchInviteAndHandle = async () => {
      if (!activationToken) return;

      try {
        const res = await getAxiosInstance(idpUrl).get(`/invites/${activationToken}`);
        const orgId = res?.data?.invite?.organizationId;

        if (orgId === 1283) {
          handleRegister("urn:ticket.siriusit.net:helsingborg_skolfed_anst");
        } else if (orgId === 1302) {
          handleRegister("https://access.bastad.se/nidp/saml2/metadata");
        } else {
          console.warn("Unhandled organization ID:", orgId);
        }
      } catch (error) {
        console.error("Failed to fetch invite data", error);
      }
    };

    fetchInviteAndHandle();
  }, [activationToken]);

  return (
    <Flex w="100vw" h="100vh" justifyContent="center" alignItems="center">
      <Box
        borderRadius="5%"
        bgColor="darkIndigo"
        borderColor="borderLight"
        borderWidth="1px"
        pos="absolute"
        zIndex="0"
        h="420px"
        w="460px"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
      >
        <VStack w="full" alignItems="stretch">
          <Heading
            as="h1"
            fontSize="22"
            fontWeight="semibold"
            lineHeight="1.6"
            mt={10}
            mb={5}
            alignSelf="center"
            color="white"
          >
            {t("Register_With_SkolFed")}
          </Heading>

          <VStack ml="5" w="full" justifyContent="center" pt="10">
            <Spinner size="lg" color="white" />
            <Text color="white" fontSize="md">
              {t("Redirecting_You_To_Login")}...
            </Text>
            {isLoading && (
              <Text color="white" fontSize="sm" mt="2">
                {t("Please_Wait")}
              </Text>
            )}
          </VStack>

          {authError && (
            <HStack w="full" justifyContent="center" pt="4">
              <Text fontWeight="light" color="white">
                {invalidCredentialsErrorMessage}
              </Text>
            </HStack>
          )}
        </VStack>
      </Box>
    </Flex>
  );
};
